import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { UserAccessService } from '../../user/access/user-access.service';
import { AuthenticationService } from '../../user/authentication.service';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard {
  constructor(
    private accessService: UserAccessService,
    private authService: AuthenticationService,
    private router: Router
  ) {}

  canMatch(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.isAdminCheck();
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.isAdminCheck();
  }

  private isAdminCheck(): Observable<boolean | UrlTree> {
    // isUserPlanUpdated already emits true for an anonymous visitor, because
    // UserAccessService runs setUserPlan(null) as soon as it is constructed.
    // Waiting for `updated && isAuthorized` therefore has to distinguish
    // "not signed in" from "signed in, user info still in flight": with an
    // access token present the unauthorized state is only the pre-fetch
    // default and a later emission will replace it, without one it is final.
    // Filtering on isAuthorized alone never emits in the second case and
    // hangs the navigation instead of redirecting.
    return this.accessService.isUserPlanUpdated.pipe(
      filter(
        (updated) =>
          updated &&
          (this.accessService.getIsAuthorized() ||
            !this.authService.hasAccessToken())
      ),
      take(1),
      map(() =>
        this.accessService.getIsAdmin()
          ? true
          : this.router.createUrlTree(['/sign-in'])
      )
    );
  }
}
